import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { DropdownModel } from '../../../models/component/dropdown.model';

@Component({
  selector: 'app-evo-form-select',
  templateUrl: './evo-form-select.component.html',
  styleUrls: ['./evo-form-select.component.css']
})
export class EvoFormSelectComponent implements OnChanges {

  @Input() list: DropdownModel[] = [];
  @Input() selected: string = null;
  @Input() placeholder = 'Select…';
  @Input() disabled = false;
  @Input() dropdownMaxHeight = '200px';
  @Output() selectedChange = new EventEmitter<string>();

  isOpen = false;
  currentItem: DropdownModel = null;

  constructor(private elRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  ngOnChanges() {
    this.syncCurrentItem();
  }

  syncCurrentItem() {
    if (!this.selected) {
      this.currentItem = null;
      return;
    }
    let found: DropdownModel = null;
    for (const item of this.list) {
      if (item.key === this.selected) {
        found = item;
        break;
      }
    }
    this.currentItem = found;
  }

  toggle() {
    if (this.disabled) {
      return;
    }
    this.isOpen = !this.isOpen;
  }

  select(item: DropdownModel) {
    this.currentItem = item;
    this.isOpen = false;
    this.selectedChange.emit(item.key);
  }

  clearSelection() {
    this.currentItem = null;
    this.isOpen = false;
    this.selectedChange.emit(null);
  }

  closeDropdown() {
    this.isOpen = false;
  }
}
